import { observable, computed } from 'mobx'
import Model from '../shared/model'

import validate from '../shared/decorators/model/validate'

@validate({
  recipientUserId: 'isRequired',
  recipientType: 'string|isRequired',
  content: 'string|minLen:1',
  // encryptedId: '',
  isRead: 'bool',
  message: 'string',
  subject: 'string|isRequired',
  // mention: null
  type: 'string|isRequired'
})
export default class Message extends Model {

  @observable recipientUserId = ''

  @observable recipientType = 'admin'

  @observable content = ''

  @observable encryptedId = ''

  @observable isRead = false

  @observable message = ''

  @observable subject = ''

  @observable mention = null

  @observable type = 'message'

  static typeMap = {
    released: 'release',
    changed: 'release',
    rejected: 'release',
    rating: 'rating',
    message: 'message'
  }

  constructor(...args) {
    super(...args)

    this.initValidate()
  }

  parseList(list) {
    return (list || []).map((itm) => ({
      value: itm.value || itm.id,
      attr: itm.pivot ? itm.pivot.amount : itm.attr
    }))
  }

  parse(data) {
    return data
  }

  @computed get asJSON() {

    return {
      recipientUserId: this.recipientUserId,
      recipientType: this.recipientType,
      content: this.content,
      encryptedId: this.encryptedId,
      isRead: this.isRead,
      message: this.message,
      subject: this.subject,
      mention: this.mention,
      type: this.type,
    }

  }

  getJSON() {
    return this.asJSON
  }

}



// WEBPACK FOOTER //
// ./src/message/model.js